import {
  formatErrorWithRequestId,
  readApiErrorEnvelope,
} from '#/utils/requestError';

/**
 * axios `responseType: 'blob'` 時，非 2xx 的 JSON 也會是 Blob；轉回物件供 apiError 讀 code。
 *
 * @param {unknown} error
 * @returns {Promise<unknown>}
 */
export async function hydrateJsonBlobError(error) {
  if (!error || typeof error !== 'object' || !('response' in error) || !error.response) {
    return error;
  }

  const response = /** @type {{ status?: number, data?: unknown }} */ (error.response);
  const status = Number(response.status) || 0;
  const data = response.data;
  if (status < 400 || !(typeof Blob !== 'undefined' && data instanceof Blob)) {
    return error;
  }

  try {
    const parsed = JSON.parse(await data.text());
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      response.data = parsed;
    }
  } catch {
    // 非 JSON 或讀取中斷時維持原樣，交給檔案傳輸文案。
  }

  return error;
}

/**
 * 下載在回應開始後中斷、或 body 不是 JSON envelope 時的文案。
 * 已還原成 JSON envelope 時回 `null`，交給各模組 apiError。
 *
 * @param {unknown} error
 * @returns {string|null}
 */
export function getFileTransferErrorMessage(error) {
  if (!error || typeof error !== 'object') {
    return '檔案傳輸失敗';
  }

  if (!('response' in error) || !error.response) {
    return '檔案傳輸失敗';
  }

  const envelope = readApiErrorEnvelope(error);
  if (envelope?.code || envelope?.message) {
    return null;
  }

  const response = /** @type {{ status?: number, data?: unknown }} */ (error.response);
  const status = Number(response.status) || 0;
  const data = response.data;
  const isBlob = typeof Blob !== 'undefined' && data instanceof Blob;
  const isRawBody = isBlob || typeof data === 'string' || data == null;
  if (status >= 400 && isRawBody) {
    return formatErrorWithRequestId('檔案傳輸失敗', envelope?.requestId);
  }

  return null;
}
